<template>
  <v-dialog
    v-model="open"
    max-width="480"
    class="comment-module-container"
    :class="yearClass"
  >
    <v-card>
      <v-card-title class="text-subtitle-1 font-weight-bold">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <v-textarea
          v-model="localComment"
          :label="$t('unitStudy.comments.commentLabel')"
          auto-grow
          clearable
          rows="3"
          variant="outlined"
          density="comfortable"
          style="min-width: 100%"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" @click="emitCancel">{{
          $t('common.cancel')
        }}</v-btn>
        <v-btn
          class="comment-module-save-btn"
          @click="emitSave"
          :disabled="saving"
        >
          {{ saving ? $t('common.saving') : $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'CommentDialog',
    props: {
      modelValue: { type: Boolean, default: false },
      paragraphId: { type: String, default: '' },
      comment: { type: String, default: '' },
      title: { type: String, default: 'Add comment' },
      saving: { type: Boolean, default: false },
      activecourse: { type: Array, default: () => [] },
    },
    emits: ['update:modelValue', 'save', 'cancel'],
    data() {
      return { localComment: '', open: this.modelValue }
    },
    computed: {
      yearClass() {
        const ac = this.activecourse
        return ac && ac[0] && ac[0].baseYear ? ac[0].baseYear : ''
      },
    },
    watch: {
      modelValue(v) {
        this.open = v
        if (v) {
          // seed on every open
          this.localComment = this.comment || ''
        }
      },
      open(v) {
        this.$emit('update:modelValue', v)
      },
      comment(v) {
        // if the prop changes while dialog is open, reflect it
        if (this.open) this.localComment = v || ''
      },
    },
    mounted() {
      this.localComment = this.comment || ''
    },
    methods: {
      emitCancel() {
        this.open = false
        this.$emit('cancel')
      },
      emitSave() {
        this.$emit('save', {
          paragraphId: this.paragraphId,
          comment: (this.localComment || '').trim(),
        })
      },
    },
  }
</script>

<style scoped>
  .comment-module-container.greenYear :deep(.v-toolbar__content),
  .comment-module-container.greenYear :deep(.comment-module-save-btn) {
    background-color: #024731;
    color: #ffffff;
  }
  .comment-module-container.blueYear :deep(.v-toolbar__content),
  .comment-module-container.blueYear :deep(.comment-module-save-btn) {
    background-color: #002b45;
    color: #ffffff;
  }
  .comment-module-container.redYear :deep(.v-toolbar__content),
  .comment-module-container.redYear :deep(.comment-module-save-btn) {
    background-color: #6e273d;
    color: #ffffff;
  }
</style>
